/*
 * @Author: chenkailun
 * @Date: 2024-10-10 17:29:30
 * @LastEditors: chenkailun
 * @LastEditTime: 2024-10-18 14:28:37
 * @Description: 
 * @FilePath: \solarbiolite\src\store\modules\resint.js
 */
// initial state
const state = {
  isShowProvince: false, 
  selectedProvince:'',
  provinceItem:'',
  ruleState:false,
  qrIntegralInfo:null
}

// mutations
const mutations = {
  setIsShowProvince(state, value) {
    state.isShowProvince = value;
  },

  setSelectedProvince(state, value) {
    state.selectedProvince = value;
  },
  setProvinceItem(state, value) {
    state.provinceItem = value;
  },

  setRuleState(state, value) {
    state.ruleState = value;
  },

  //扫码领积分
  setQrIntegralInfo(state, value) {
    state.qrIntegralInfo = value;
  },

}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/resint.js